export enum DishRatingFilter {
  SIXTY_PERCENT_PLUS = 60,
  SEVENTY_PERCENT_PLUS = 70,
  EIGHTY_PERCENT_PLUS = 80,
  NINETY_PERCENT_PLUS = 90,
}

export const DEFAULT_DISH_RATING_FILTER = DishRatingFilter.EIGHTY_PERCENT_PLUS;
